.kdx-card-links {
	
	div[class^="col"] {
		margin: 0 0 ($gutter-def * 1.5);
		padding-left: 14px;
		padding-right: 14px;

	}

	.kdx-card-link {
		height: 100%;
	
	}

	// Customer Scope
	&.card-links {

		> .row {
			margin: 0 #{-1 * $gutter-sm};
		}

		div[class^="col"] {
			margin: 0 0 $gutter-sm;
			padding: 0 $gutter-sm;
		}
	}
}
